import { render, staticRenderFns } from "./ActionPlans.vue?vue&type=template&id=bbf5e786&scoped=true&"
import script from "./ActionPlans.vue?vue&type=script&lang=js&"
export * from "./ActionPlans.vue?vue&type=script&lang=js&"
import style0 from "./ActionPlans.vue?vue&type=style&index=0&id=bbf5e786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf5e786",
  null
  
)

export default component.exports